<template>
  <v-main class="frontend-layout">
    <slot></slot>
  </v-main>
</template>

<script>
import '@/assets/scss/webble.frontend.scss'
import '@/assets/scss/webble.mobile.scss'

export default {
  name: 'FrontendLayout'
}
</script>
